import { render, staticRenderFns } from "./modal-crg-notes.vue?vue&type=template&id=1d952f40&scoped=true"
import script from "./modal-crg-notes.vue?vue&type=script&lang=js"
export * from "./modal-crg-notes.vue?vue&type=script&lang=js"
import style0 from "./modal-crg-notes.vue?vue&type=style&index=0&id=1d952f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d952f40",
  null
  
)

export default component.exports